import CalendarLeftPane from './CalendarLeftPane';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { toggleCalendarLeftPaneExpansion, getIsLeftNavShown } from 'owa-calendar-layout';
import { isShySuiteHeaderMode } from 'owa-suite-header-store';
import { getPalette } from 'owa-theme';
import * as React from 'react';
import { isFeatureEnabled } from 'owa-feature-flags';

const styles = require('./SidePaneOverlay.scss');
const calendarLeftPaneAsOverlayWidth = 242;

export default observer(function CalendarLeftPaneAsOverlay({
    toggleHamburgerButton,
}: {
    toggleHamburgerButton: () => void;
}) {
    const palette = getPalette();
    const calendarLeftPaneAsOverlayWidthString = calendarLeftPaneAsOverlayWidth + 'px';
    return (
        <Panel
            className={classNames(
                styles.overlayPane,
                {
                    isShyHeaderMode: isShySuiteHeaderMode(),
                },
                isFeatureEnabled('tri-metaOsRail') && styles.metaOsStyles
            )}
            styles={{
                main: {
                    /* setting a static width for overlay nav panes of 242px for styling purposes
                     * as by design we don't provide the user a resize handle or use their
                     * calendarLeftWidth value
                     */
                    width: calendarLeftPaneAsOverlayWidthString,
                    // We need to move the panel 'underneath' the hamburger button since it's above the folder pane if it the MetaOs rail is on
                    left: isFeatureEnabled('tri-metaOsRail') ? '-48px' : '0px',
                },
                content: {
                    height: '100%',
                    padding: '0',
                },
                scrollableContent: {
                    height: '100%',
                    overflow: 'hidden',
                },
                contentInner: {
                    background: palette.neutralLighter,
                },
                commands: {
                    margin: 0,
                },
            }}
            isLightDismiss={true}
            overlayProps={{
                isDarkThemed: true,
            }}
            isOpen={getIsLeftNavShown()}
            hasCloseButton={false}
            onOuterClick={onOuterClick}
            focusTrapZoneProps={{
                forceFocusInsideTrap: false,
                isClickableOutsideFocusTrap: true,
            }}
            onDismiss={toggleCalendarLeftPaneExpansion}
            type={PanelType.smallFixedNear}>
            <CalendarLeftPane
                leftNavWidthOverride={calendarLeftPaneAsOverlayWidth}
                toggleHamburgerButton={toggleHamburgerButton}
                shouldAutoFocusHamburgerButton={false}
            />
        </Panel>
    );
});

function onOuterClick() {
    // Need stub implemetation of onOuterClick to ensure this function is called instead of onDismiss
    // for the cases where the user clicks in the left rail area. Prevents the bug where a user clicks
    // the hamburger button and the pane collapses and immediately re expands.
    return;
}
